var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "password-confirmation-container" }, [
    _c("img", {
      attrs: {
        src: require("@/common/assets/images/akkodis-letter.svg"),
        alt: "letter"
      }
    }),
    _c("h2", [_vm._v("Check your email with your new password")]),
    _c("span", [
      _vm._v(
        "If there is an email in our system, we will send the password to that email address"
      )
    ]),
    _c("button", { on: { click: _vm.returnToSignIn } }, [
      _vm._v("GO BACK TO LOGIN")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }